import React from 'react';
import {
 Card, CardContent
} from 'shared/components/ui/card';
import {
 Badge
} from 'shared/components/ui/badge';
import {
 Button
} from 'shared/components/ui/button';
import {
 Upload, Sparkles, SlidersHorizontal, ArrowLeft
} from 'lucide-react';

interface ConnectionMethodSelectProps {
    onSelectManual: () => void;
    onSelectImport: () => void;
    onSelectAI: () => void;
    onBack: () => void;
}

const methods = [
    {
        id: 'import',
        title: 'Import from API Specification',
        description: 'Fastest for APIs. Upload an OpenAPI (Swagger) file to auto-configure the connection, schemas, and workflows.',
        icon: Upload,
        comingSoon: false,
    },
    {
        id: 'ai',
        title: 'Describe with AI',
        description: 'Great for common services. Describe the service you want to connect to in plain English.',
        icon: Sparkles,
        comingSoon: false,
    },
    {
        id: 'manual',
        title: 'Configure Manually',
        description: 'For databases and custom sources. Select your source type and fill in the details yourself.',
        icon: SlidersHorizontal,
        comingSoon: false,
    },
];

const ConnectionMethodSelect: React.FC<ConnectionMethodSelectProps> = ({
 onSelectManual, onSelectImport, onSelectAI, onBack
}) => {
    const handleClick = (id: string) => {
        if (id === 'manual') onSelectManual();
        if (id === 'import') onSelectImport();
        if (id === 'ai') onSelectAI();
    };

    return (
        <div className="flex flex-col gap-8 max-w-4xl mx-auto py-8">
            <div>
                <Button variant="ghost" size="sm" onClick={onBack} className="mb-4">
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Back to Connections
                </Button>
                <h2 className="text-2xl font-bold">Create New Connection</h2>
                <p className="text-muted-foreground mt-1">Choose how you'd like to set up your connection</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {methods.map((method) => (
                    <Card
                        key={method.id}
                        className={
                            method.comingSoon
                                ? 'opacity-60 cursor-not-allowed'
                                : 'cursor-pointer transition-all hover:shadow-md hover:ring-2 hover:ring-primary/20'
                        }
                        onClick={() => !method.comingSoon && handleClick(method.id)}
                    >
                        <CardContent className="p-6 flex flex-col items-center text-center gap-4 h-full">
                            <div className="rounded-full bg-muted p-4 mt-2">
                                <method.icon className="h-8 w-8" />
                            </div>
                            <div className="flex flex-col gap-2 flex-1">
                                <h3 className="font-semibold text-lg">{method.title}</h3>
                                <p className="text-sm text-muted-foreground leading-relaxed">
                                    {method.description}
                                </p>
                            </div>
                            {method.comingSoon && (
                                <Badge variant="secondary" className="">Coming Soon</Badge>
                            )}
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default ConnectionMethodSelect;
